import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import * as Accordion from '@radix-ui/react-accordion';
import type { Swiper as SwiperType } from 'swiper/types';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSwimmingPool, faSun, faDumbbell, faLaptop, faBicycle, faShuttleVan, faBaby, faDoorClosed } from '@fortawesome/free-solid-svg-icons';

import { text } from '../text';
import { URLS } from '../config';
import { hooks } from '../hooks';
import { utils } from '../utils';
import { items } from '../items';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { course as elements } from '../course';
import properties from '../staticdata/properties';
import { reviewsData } from '../staticdata/reviewData';
import { ReviewCard } from '../reviews/reviewCard';
import { roomTypes } from '../staticdata/roomOptions';
import { FlatPrices } from '../items/Flattypes';
import { PropertiyOwner } from '../items/PropertyOwner';
import { BlockHeading } from '../components/BlockHeading';
import goal from '../assets/nestfin/goal.png'
import checkIcon from '../assets/nestfin/checklist.png'
import { WhatsappSvg } from '../assets/svg/WhatsappSvg';
import useApi from '../customHook/useApi';
import { fetchPropertyByFilters, getPropertyById } from '../environment';
import { callService } from '../customHook/callService';

type RoomOption = {
  property_room_option_id: string;
  property_id: string;
  room_type_id: string;
  option_name: string;
  unit_amount: number;
  created_at: string;
  features: {
    id: string;
    name: string;
  }[];
};

type ApiResponse = {
  statusCode: number;
  success: boolean;
  message: string;
  data: RoomOption[];
};

const lessons = [
  {
    id: 1,
    title: '01. Introduction',
    lecture: '3 lectures',
    duration: '7 min',
    content: [
      {
        id: 1,
        title: 'Setting up individual Camera Rigs',
        duration: '00:44',
      },
      {
        id: 2,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '03:49',
      },
      {
        id: 3,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '02:22',
        locked: true,
      },
    ],
  },
  {
    id: 2,
    title: '02. Movement in VR',
    lecture: '8 lectures',
    duration: '1h 33 min',
    content: [
      {
        id: 1,
        title: 'Setting up individual Camera Rigs',
        duration: '00:44',
      },
      {
        id: 2,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '03:49',
      },
      {
        id: 3,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '02:22',
        locked: true,
      },
    ],
  },
  {
    id: 3,
    title: '03. Distance Grabber',
    lecture: '8 lectures',
    duration: '1h 33 min',
    content: [
      {
        id: 1,
        title: 'Setting up individual Camera Rigs',
        duration: '00:44',
      },
      {
        id: 2,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '03:49',
      },
      {
        id: 3,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '02:22',
        locked: true,
      },
    ],
  },
  {
    id: 4,
    title: '04. Snap Zones',
    lecture: '8 lectures',
    duration: '1h 33 min',
    content: [
      {
        id: 1,
        title: 'Setting up individual Camera Rigs',
        duration: '00:44',
      },
      {
        id: 2,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '03:49',
      },
      {
        id: 3,
        title: 'Setting Up VRTKs Tracked Alias',
        duration: '02:22',
        locked: true,
      },
    ],
  },
];

const tabs = [
  {
    id: 1,
    name: 'Description',
  },
  {
    id: 2,
    name: 'Lessons',
  },
  {
    id: 3,
    name: 'Instructor',
  },
  {
    id: 4,
    name: 'Reviews',
  },
];

const reviews = [
  {
    id: 1,
    name: 'Lillian Davis',
    rating: 5,
    date: 'March 3, 2022',
    comment: 'Lots of good info.',
    avatar: 'https://george-fx.github.io/nuton_api/assets/users/02.jpg',
  },
  {
    id: 2,
    name: 'Adam Thompson',
    rating: 5,
    date: 'March 28, 2022',
    comment: 'Great course!',
    avatar: 'https://george-fx.github.io/nuton_api/assets/users/03.jpg',
  },
  {
    id: 3,
    name: 'Ryan Howard',
    rating: 5,
    date: 'February 12, 2022',
    comment: 'It was a great course.',
    avatar: 'https://george-fx.github.io/nuton_api/assets/users/04.jpg',
  },
];

type PropertyDetailState = {
  leadId: string;
  propertyId: string;
};



export interface Feature {
  icon: string;
  feature_id: number;
  feature_name: string;
}

export interface RoomType {
  room_type_id: string;
  room_type_name: string;
}

export interface PropertyType {
  property_id: string;
  property_name: string;
  contact_phone: string;
  contact_email: string;
  address: string;
  locality_id: string;
  locality_name: string | null;
  city_id: string;
  city_name: string;
  pincode: string;
  security_deposit_months: string;
  agreement_duration_months: string;
  noticeperiod_months: string;
  lockinperiod_months: string;
  state: string;
  features: Feature[];
  photos: any;
  minimum_rent: number;
  room_types: RoomType[];
}

export interface APIResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
  message: string;
}



export interface FilterResponse {
  success: boolean;
  statusCode: number;
  data: PropertyType[];
}




export const CourseDetails: React.FC = () => {
  const location = useLocation();
  const { pathname } = useLocation();
  const navigate = hooks.useNavigate();
  const course = location.state.course;
  const [coursesData, setCoursesData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [propertiesDetailsData, setPropertiesDetailsData] = useState<PropertyType | null>(null);

  // const [selectedTab, setSelectedTab] = useState(tabs[0]);
  // const [openItem, setOpenItem] = useState<string | null>(null);

  const [propertiesDetail, setPropertryDetails] = useState<PropertyDetailState>({
    leadId: "",
    propertyId: ""
  });


  const [isModalOpen, setIsModalOpen] = useState(false);





  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
    };
    scrollToTop();
  }, [pathname]);

  const getData = async () => {
    setLoading(true);

    try {
      const results = await Promise.allSettled([
        axios.get(URLS.GET_COURSES),
        // axios.get(URLS.GET_BANNERS),
      ]);
      const coursesResponse = properties;
      if (coursesResponse.status === 'fulfilled') {
        setCoursesData(coursesResponse.properties);
      } else {
        // console.error('Error fetching courses:', coursesResponse.reason);
      }
      // const productsResponse = results[0];
      // const bannersResponse = results[1];
      // if (productsResponse.status === 'fulfilled') {
      //   setProductsData(productsResponse.value.data.products);
      // } else {
      //   console.error('Error fetching products:', productsResponse.reason);
      // }
      // if (bannersResponse.status === 'fulfilled') {
      //   setBannersData(bannersResponse.value.data.banners);
      // } else {
      //   console.error('Error fetching banners:', bannersResponse.reason);
      // }
    } catch (error) {
      console.error('Unexpected error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);
  const [previewImageIndex, setPreviewImageIndex] = useState(0);


  // API CALL
  const {
    data: propertyDetailData,
    loading: propertyDetailLoading,
    callApi: fetchPropertyDetail,
  } = useApi<APIResponse>(getPropertyById, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  useEffect(() => {
    const propertyId = location.state?.property_id || "";
    const leadId = localStorage.getItem("lead_profile_id") || "";

    setPropertryDetails({ leadId, propertyId });

    fetchPropertyDetail({
      // leadId: leadId,
      // propertyId: propertyId,
      leadId: "LEAD-B-2025-05-001",
      propertyId: "PR-B-2025-05-078",
    });


    if (leadId && propertyId) {
      callService("PROPERTY_DETAIL", [
        {
          param: "PROPERTY_ID",
          value: propertyId,
        },
      ])
        .then((res) => {
          console.log("✅ PROPERTY_DETAIL response:", res);

          // Set data if structure is like: { data: [ ... ] }
          if (res?.data?.length) {
            setPropertiesDetailsData(res.data[0]);
          }
        })
        .catch((err) => {
          console.error("❌ PROPERTY_DETAIL API failed:", err);
        });
    }
  }, [location.state]);


  // ✅ Debug API response
  useEffect(() => {
    if (propertyDetailData) {
      console.log("✅ propertyDetailData response:", propertyDetailData.data[0]);
      setPropertiesDetailsData(propertyDetailData.data[0])
    }
  }, [propertyDetailData]);




  // Call Lead API Call 
  useEffect(() => {

  }, [])




  // fetch all property Here


  // CAll Api 
  const {
    data: propertyData,
    loading: propertyLoading,
    callApi: fetchProperty,
  } = useApi<FilterResponse>(fetchPropertyByFilters, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });



  useEffect(() => {

    // ✅ Call API immediately
    const payload = {
      leadId: "LEAD-B-2025-05-001",
      gender: "GENDER_MALE",
      minAmount: 1,
      maxAmount: 100000,
      localityId: "5,7",
    };

    fetchProperty(payload);
    console.log("Called API immediately with:", payload);
  }, []);


  useEffect(() => {
    console.log(propertyData?.data, "propertyData")
  }, [propertyData])

  // Start Component Here
  function renderPreviewImage(): JSX.Element {
    const images = course?.previewImages || [course?.preview_90x90];

    return (
      <div style={{ marginTop: 20, marginBottom: 20 }} className='container-fluid'>
        <Swiper
          spaceBetween={16}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          loop
        >

          {images.map((image: any, index: number) => (


            <SwiperSlide key={index}>
              <img
                src={image}
                alt={`Preview ${index + 1}`}
                onClick={() => {
                  setPreviewImageIndex(index);
                  setIsImagePreviewOpen(true);
                }}
                style={{
                  width: '100%',
                  objectFit: 'cover',
                  borderRadius: 10,
                  height: 200,
                  cursor: 'pointer',
                }} />
            </SwiperSlide>
          )

          )}
        </Swiper>
      </div>

    );
  }


  // const renderPreviewImage = (): JSX.Element => {
  //   const placeholderImage =
  //     'https://media.istockphoto.com/id/1409329028/vector/no-picture-available-placeholder-thumbnail-icon-illustration-design.jpg?s=612x612&w=0&k=20&c=_zOuJu755g2eEUioiOUdz_mHKJQJn-tDgIAhQzyeKUQ=';

  //   // Ensure images is always an array
  //   const images: string[] = Array.isArray(course?.previewImages) && course.previewImages.length > 0
  //     ? course.previewImages
  //     : course?.preview_90x90
  //       ? [course.preview_90x90]
  //       : [placeholderImage];

  //   return (
  //     <div style={{ marginTop: 20, marginBottom: 20 }} className="container-fluid">
  //       <Swiper
  //         spaceBetween={16}
  //         slidesPerView={1}
  //         navigation
  //         pagination={{ clickable: true }}
  //         loop
  //       >
  //         {images.map((image, index) => (
  //           <SwiperSlide key={index}>
  //             <img
  //               src={image || placeholderImage}
  //               alt={`Preview ${index + 1}`}
  //               onClick={() => {
  //                 setPreviewImageIndex(index);
  //                 setIsImagePreviewOpen(true);
  //               }}
  //               style={{
  //                 width: '100%',
  //                 objectFit: 'cover',
  //                 borderRadius: 10,
  //                 height: 200,
  //                 cursor: 'pointer',
  //               }}
  //               onError={(e) => {
  //                 (e.target as HTMLImageElement).src = placeholderImage;
  //               }}
  //             />
  //           </SwiperSlide>
  //         ))}
  //       </Swiper>
  //     </div>
  //   );
  // };


  const renderHeader = (): JSX.Element => {
    return (
      <components.Header

        goBack={true}
        course={course}
        // addWishlist={true}
        title={"Model Town, Delhi "}
      />
    );
  };

  const renderRating = (): JSX.Element => {
    return (
      <div
        style={{ ...utils.rowCenter({ gap: 6 }), marginBottom: 20 }}
        className='container'
      >
        <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
          <text.T10
            style={{
              ...theme.fonts.Lato_700Bold,
              color: '#FFC700',
              marginTop: 3,
            }}
          >
            5.0
          </text.T10>
          <components.Rating />
        </div>
        <text.T10>(149 ratings) 2,719 students</text.T10>
      </div>
    );
  };


  const renderLocation = (): JSX.Element | null => {
    let locatonitem = [{
      id: 1,
      name: "Dev Rawat",
      phone: "1234567890",
      ownertype: "owner",
      profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
    }]
    return (
      <div
        style={{ marginBottom: 20 }}
        className='container'
      >
        {locatonitem.map((item, index, array) => {
          const isLast = index === array.length - 1;
          return (
            <items.LocationItem
              key={item.id}
              review={item}
              isLast={isLast}
            />
          );
        })}
      </div>
    );
  };


  const renderTopRatedCourses = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 80, marginTop: 40 }}>
        <components.BlockHeading
          title='Similar Properties'
          viewAllOnClick={() => {
            navigate('/category-list', {
              state: {
                title: 'Similar Properties',
                propertyList: propertyData?.data,
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        {propertyData?.data.slice(0, 3).map((course: any, index, array) => {
          const isLast = index === array.length - 1;

          return (
            <elements.CourseCard
              key={course.id}
              course={course}
              isLast={isLast}
              section='top rated'
            />
          );
        })}

      </div>
    );
  };


  const renderReview = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <components.BlockHeading
          title='Reviews'
          viewAllVisible={false}
          viewAllOnClick={() => {
            // navigate('/category-list', { state: { title: 'Nearest For You' } });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          pagination={{ clickable: true }}
          className="review-swiper"
        >
          {reviewsData?.map((review: any) => {
            return (
              <SwiperSlide key={review.id} className="review-card">
                <div className="review-header">
                  <div className="review-avatar">
                    {review.image ? (
                      <img src={review.image} alt={review.name} />
                    ) : (
                      <span className="review-initials">
                        {review.name
                          ?.split(' ')
                          .map((n: string) => n[0])
                          .join('')
                          .toUpperCase()}
                      </span>
                    )}
                  </div>

                  <div className="review-info">
                    <div className="review-name">{review.name}</div>
                    <div className="review-rating">★ {review.rating}</div>
                  </div>
                </div>

                <div className="review-body">
                  <div className="review-title">{review.title}</div>
                  <div className="review-description">{review.description}</div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>

      </div>
    );
  };





  // Room Option Component 
  // const roomOptions = [
  //   {
  //     title: 'Option 1',
  //     sharingType: 'Multi Sharing',
  //     price: 'Rs. 6,000/bed',
  //     deposit: 'Rs. 8,000',
  //     services: ['Wi-Fi', 'Housekeeping', 'Laundry', 'AC'],
  //   },
  //   {
  //     title: 'Option 2',
  //     sharingType: 'Single Sharing',
  //     price: 'Rs. 10,000/bed',
  //     deposit: 'Rs. 12,000',
  //     services: ['Wi-Fi', 'Attached Bathroom'],
  //   },
  //   {
  //     title: 'Option 3',
  //     sharingType: 'Double Sharing',
  //     price: 'Rs. 8,000/bed',
  //     deposit: 'Rs. 9,000',
  //     services: ['AC', 'Shared Kitchen', 'Housekeeping', 'Wi-Fi', 'Laundry', 'Common Area'],
  //   },
  //   {
  //     title: 'Option 4',
  //     sharingType: 'Private',
  //     price: 'Rs. 12,000/bed',
  //     deposit: 'Rs. 15,000',
  //     services: ['AC', 'Private Bathroom', '24x7 Power Backup', 'Wi-Fi', 'Fridge', 'Geyser'],
  //   },
  // ];


  // const renderRoomOffer = (): JSX.Element => {
  //   return (
  //     <div className='RoomTypeContainer' style={{ marginBottom: 0, marginTop: 40, padding: '0px 20px' }}>
  //       <components.BlockHeading
  //         title='Room Offering'
  //         viewAllVisible={false}
  //         viewAllOnClick={() => {
  //           // navigate('/category-list', { state: { title: 'Nearest For You' } });
  //         }}
  //         containerStyle={{ marginBottom: 12 }}
  //       />

  //       {roomOptions.map((room, index) => (
  //         <div className='RoomTypeContent' key={index}>
  //           <h4>{room.title}</h4>
  //           <div className='sharingType'>
  //             <p>{room.sharingType}</p>
  //             <p>{room.price}</p>
  //           </div>
  //           <div className='depositAmount'>
  //             <p>One Time Security Deposit</p>
  //             <p>{room.deposit}</p>
  //           </div>
  //           <p className='servicesRoom'>Services </p>
  //           <ul>
  //             {room.services.map((service, i) => (
  //               <li key={i}>{service}</li>
  //             ))}
  //           </ul>
  //         </div>
  //       ))}
  //     </div>
  //   );
  // };



  const renderLocationMap = (): JSX.Element => {
    return (
      <div style={{ marginBottom: 0, marginTop: 40 }}>
        <components.BlockHeading
          title='Property Location'
          viewAllVisible={false}
          viewAllOnClick={() => {
            // navigate('/category-list', { state: { title: 'Nearest For You' } });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />

        <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>
          <iframe
            title="Noida Sector 16 Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.712100232856!2d77.31495772549884!3d28.578406725694343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce45b03df3a13%3A0xaeba1ce26aa125fc!2sNoida%20Sec%2016!5e0!3m2!1sen!2sin!4v1749128786731!5m2!1sen!2sin"
            width="100%"
            height="250"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

      </div>
    );
  };

  const renderKeyHighlights = (): JSX.Element => {
    return (
      <div className='container whyYouChooseProperties' style={{ marginBottom: 30, padding: "20px 28px", backgroundColor: "#f0fff0" }} >
        <div className="highlightContainer">
          <div className="highlightImage">
            <img src={goal} alt="Goal" />
          </div>
          <div className="highlightText">
            <p className="headingChoose">Other Key Highlights</p>
            <p>Why you should choose the property</p>
          </div>
        </div>
        <ul className="whyChooseList">
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Prime location & transport access
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Spacious, modern interiors
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            24/7 security system
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Eco-friendly with green space
          </li>
          <li>
            <img src={checkIcon} alt="check" className="listIcon" />
            Great value & ROI
          </li>
        </ul>


      </div >
    );
  };
  // Function to render the Amenities as individual blocks





  const renderScheduleButton = (): JSX.Element => {
    return (
      <div style={{ padding: '30px 20px', textAlign: 'center', width: "100%" }}>
        <button
          style={{
            backgroundColor: '#7065F0',
            color: '#ffffff',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: 600,
            cursor: 'pointer',
            width: "100%",
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            transition: 'all 0.3s ease',
          }}
          onClick={() => {
            const propertyId = propertiesDetailsData?.property_id;
            const propertyName = propertiesDetailsData?.property_name;

            // ✅ Only store if property_id exists
            if (propertyId) {
              sessionStorage.setItem("property_id", propertyId);
            }

            if (propertyName) {
              sessionStorage.setItem("property_name", propertyName);
            }

            navigate("/room-type", {
              state: {
                property_id: propertyId,
                property_name: propertyName,
              },
            });
          }}


        // onClick={() => alert('Visit scheduled!')}
        // onMouseEnter={(e) =>
        //   ((e.target as HTMLButtonElement).style.backgroundColor = '#3a59d8')
        // }
        // onMouseLeave={(e) =>
        //   ((e.target as HTMLButtonElement).style.backgroundColor = '#4B6EF5')
        // }
        >
          View Room Option
        </button>
      </div >
    );
  };


  // Render Component



  const renderTitle = (): JSX.Element => {
    return (
      <div className='container propertiesDetails'>
        <p className='typeOfRoom'  >Semi Furnished</p>
        <text.H4
          style={{ marginBottom: 6 }}
          numberOfLines={2}
        >
          {/* {course.name} */}
          {/* {propertiesDetailsData?.property_name} */}
          {propertiesDetailsData?.property_name}

          {/* PG Accommodation in Downtown */}
        </text.H4>
      </div>
    );
  };

  // room types 
  // const renderFlatOpton = (): JSX.Element => {
  //   let options = [{
  //     id: 1,
  //     amount: "8000",
  //     roomtype: "Flat",
  //     address: "Gurgaon,ram colony,Delhi.",
  //     securtydeposit: "25000",
  //     totalbeds: "3",
  //     totabatrooms: "2",
  //     area: "50",
  //     profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
  //   }]


  //   return (
  //     <div
  //       style={{ marginBottom: 20 }}
  //       className='container'
  //     >
  //       {options.map((item, index, array) => {
  //         const isLast = index === array.length - 1;
  //         return (
  //           <FlatPrices
  //             key={item.id}
  //             review={item}
  //             isLast={isLast}
  //           />
  //         );
  //       })}
  //     </div>
  //   );
  // }


  const renderFlatOpton = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;
    return (
      <div style={{ marginBottom: 20 }} className='container'>
        <FlatPrices
          key={propertiesDetailsData.property_id}
          review={propertiesDetailsData}
          isLast={true}
        />
      </div>
    );
  };


  // const renderOwner = (): JSX.Element | null => {
  //   if (!propertiesDetailsData) return null;

  //   let propertyOwner = [{
  //     id: 1,
  //     name: "Vikas Kumar",
  //     phone: "1234567890",
  //     ownertype: "owner",
  //     profileimage: "https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
  //   }]
  //   return (
  //     <div
  //       // style={{ marginBottom: 20 }}
  //       className='container'
  //     >
  //       {propertyOwner.map((item, index, array) => {
  //         const isLast = index === array.length - 1;
  //         return (
  //           <PropertiyOwner
  //             key={item.id}
  //             review={item}
  //             isLast={isLast}
  //             onCalendarClick={() => navigate("/room-type")}
  //           />
  //         );
  //       })}
  //     </div>
  //   );
  // };



  const renderOwner = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;

    // let propertyOwner = [{
    //   id: 1,
    //   name: "Vikas Kumar",
    //   phone: "1234567890",
    //   ownertype: "owner",
    //   profileimage: "https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
    // }]

    return (
      <div
        // style={{ marginBottom: 20 }}
        className='container'
      >
        <PropertiyOwner
          key={propertiesDetailsData.property_id}
          review={propertiesDetailsData}
          isLast={true}
          onCalendarClick={() => navigate("/room-type")}
        />
      </div>
    );
  };



  const renderAmenities = (): JSX.Element => {
    const amenitiesList = [
      { id: 1, name: 'Infinity Pool', icon: <FontAwesomeIcon icon={faSwimmingPool} color='#7065F0' /> },
      { id: 2, name: 'Sunset View', icon: <FontAwesomeIcon icon={faSun} color='#7065F0' /> },
      { id: 3, name: 'Gym Center', icon: <FontAwesomeIcon icon={faDumbbell} color='#7065F0' /> },
      { id: 4, name: 'Work Station', icon: <FontAwesomeIcon icon={faLaptop} color='#7065F0' /> },
      // { id: 5, name: 'Free Bike', icon: <FontAwesomeIcon icon={faBicycle} color='#7065F0' /> },
      // { id: 6, name: 'Airport Shuttle', icon: <FontAwesomeIcon icon={faShuttleVan} color='#7065F0' /> },
      { id: 7, name: 'Baby Ground', icon: <FontAwesomeIcon icon={faBaby} color='#7065F0' /> },
      { id: 8, name: 'Meeting Room', icon: <FontAwesomeIcon icon={faDoorClosed} color='#7065F0' /> },
    ];

    return (
      <div className="amenities-wrapper" style={{ marginBottom: 30 }}>
        <BlockHeading

          title="Amenities"
          viewAllOnClick={() => {
            navigate('/aminity-list', {
              state: {
                title: 'Amenities List',
                features: propertiesDetailsData?.features || [],
              },
            });
          }}
          containerStyle={{ marginBottom: 12, padding: '0 20px' }}
        />
        <div className="amenities-grid">
          {propertiesDetailsData?.features.slice(0, 6).map((item) => (
            <div key={item.feature_id} className="amenity-card">
              {/* <div className="amenity-icon">{item.icon}</div> */}
              <div className="amenity-icon">
                <img src={item.icon} alt="" />
                {/* {item.icon} */}
              </div>
              <div className="amenity-name">{item.feature_name}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };



  const propertyDetails = (): JSX.Element | null => {
    if (!propertiesDetailsData) return null;

    const details = [
      { label: 'Furnished', value: 'Semi Furnished' },
      { label: 'Ownership', value: 'Leasehold' },
      { label: 'Security Deposit', value: propertiesDetailsData.security_deposit_months },
      { label: 'Notice Period', value: propertiesDetailsData.noticeperiod_months },
      // You can uncomment and use the below if the API provides them
      // { label: 'Agreement', value: propertiesDetailsData.agreement_duration_months },
      // { label: 'Lock-in Period', value: propertiesDetailsData.lockinperiod_months },
    ];

    return (
      <div className='container'>
        <div className='propertyContainer'>
          <p className="property-details">Property Details</p>
          <div className='detailsValue'>
            {details.map((item, index) => (
              <div className='propertyDetails-content' key={index}>
                <p>{item.label}</p>
                <p>{item.value}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };


  const renderBottomTabBar = (): JSX.Element => {
    return <components.BottomTabBar />;
  };



  const renderBottomButton = (): JSX.Element => {
    return (
      <div className="container">
        <div className="bottom-button-container">
          {/* <button
          onClick={() => window.open("https://wa.me/919999999999", "_blank")}
          className="bottom-button whatsapp-button"
        >
          <WhatsappSvg />
        </button> */}

          <button
            onClick={() => window.open("https://wa.me/919999999999", "_blank")}
            className="bottom-button whatsapp-button"
          >
            <WhatsappSvg className="whatsapp-icon-animate" />
          </button>

          <button
            onClick={() => (window.location.href = "tel:+919999999999")}
            className="bottom-button call-button "
          >
            Call Now
          </button>

          <button
            // onClick={() => setIsModalOpen(true)}
            // onClick={() =>
            //   navigate("/room-type", {
            //     state: {
            //       property_id: propertiesDetailsData?.property_id,
            //       property_name: propertiesDetailsData?.property_name,
            //     },
            //   })
            // }
            onClick={() => {
              const propertyId = propertiesDetailsData?.property_id;
              const propertyName = propertiesDetailsData?.property_name;

              // ✅ Only store if property_id exists
              if (propertyId) {
                sessionStorage.setItem("property_id", propertyId);
              }

              if (propertyName) {
                sessionStorage.setItem("property_name", propertyName);
              }

              navigate("/room-type", {
                state: {
                  property_id: propertyId,
                  property_name: propertyName,
                },
              });
            }}
            className="bottom-button request-button"
          >
            Book Now
          </button>


          {isModalOpen && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Book Your Room</h2>
                <form>
                  <label>
                    Select Room Type:
                    <select required>
                      <option value="">-- Choose an option --</option>
                      <option value="multi">Multi Sharing</option>
                      <option value="single">Single Sharing</option>
                      <option value="double">Double Sharing</option>
                      <option value="private">Private</option>
                    </select>
                  </label>

                  <label>
                    Payment Amount:
                    <input type="text" value="Rs. 10,000" readOnly />
                  </label>

                  <label>
                    GST (18%):
                    <input type="text" value="Rs. 1,800" readOnly />
                  </label>

                  <label>
                    Total Payable:
                    <input type="text" value="Rs. 11,800" readOnly />
                  </label>

                  <div className="modal-buttons">
                    <button
                      type="button"
                      className="cancel-button"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <div className="pay-button"
                      onClick={() => navigate('/choose-payment-method')}
                    >Confirm</div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };



  const swiperRef = useRef<SwiperType | null>(null);

  const renderContent = (): JSX.Element => {
    return (
      <main style={{ paddingBottom: 0 }}>
        {renderPreviewImage()}

        {renderTitle()}
        {renderFlatOpton()}
        {renderOwner()}
        {renderScheduleButton()}
        {propertyDetails()}
        {/* {renderRoomOffer()} */}
        {renderAmenities()}
        {renderKeyHighlights()}
        {renderLocationMap()}
        {renderReview()}
        {renderTopRatedCourses()}
        {renderBottomButton()}
        {/* {renderBottomTabBar()} */}


        {/* {renderLocation()} */}


        {isImagePreviewOpen && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              zIndex: 9999,
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsImagePreviewOpen(false)}
              style={{
                position: 'absolute',
                top: 20,
                right: 20,
                background: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: 28,
                cursor: 'pointer',
                zIndex: 10000,
              }}
            >
              ✕
            </button>

            {/* Custom Prev Button */}
            <button
              onClick={() => swiperRef.current?.slidePrev()}
              style={{
                position: 'absolute',
                left: 20,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 40,
                color: '#fff',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                zIndex: 10000,
              }}
            >
              ‹
            </button>

            {/* Custom Next Button */}
            <button
              onClick={() => swiperRef.current?.slideNext()}
              style={{
                position: 'absolute',
                right: 20,
                top: '50%',
                transform: 'translateY(-50%)',
                fontSize: 40,
                color: '#fff',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                zIndex: 10000,
              }}
            >
              ›
            </button>

            {/* Swiper Fullscreen View */}
            <Swiper
              initialSlide={previewImageIndex}
              onSlideChange={(swiper: SwiperType) => setPreviewImageIndex(swiper.activeIndex)}
              onSwiper={(swiperInstance: SwiperType) => (swiperRef.current = swiperInstance)}
              spaceBetween={10}
              style={{ height: '100%', width: '100%' }}
            >
              {course?.previewImages.map((image: string, index: number) => (
                <SwiperSlide key={index}>
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <img
                      src={image}
                      alt={`Fullscreen ${index + 1}`}
                      style={{
                        maxHeight: '90%',
                        maxWidth: '90%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}


      </main>
    );
  };

  return (
    <>
      {/*  */}
      {renderHeader()}
      {renderContent()}
    </>
  );
};






// ************************* OLD CODE 07-06-2025 *************************************

// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import * as Accordion from '@radix-ui/react-accordion';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSwimmingPool, faSun, faDumbbell, faLaptop, faBicycle, faShuttleVan, faBaby, faDoorClosed } from '@fortawesome/free-solid-svg-icons';

// import { text } from '../text';
// import { URLS } from '../config';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { items } from '../items';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { course as elements } from '../course';
// import properties from '../staticdata/properties';
// import { reviewsData } from '../staticdata/reviewData';
// import { ReviewCard } from '../reviews/reviewCard';
// import { roomTypes } from '../staticdata/roomOptions';
// import { FlatPrices } from '../items/Flattypes';
// import { PropertiyOwner } from '../items/PropertyOwner';
// import { BlockHeading } from '../components/BlockHeading';
// import goal from '../assets/nestfin/goal.png'
// import checkIcon from '../assets/nestfin/checklist.png'
// import { WhatsappSvg } from '../assets/svg/WhatsappSvg';

// type RoomOption = {
//   property_room_option_id: string;
//   property_id: string;
//   room_type_id: string;
//   option_name: string;
//   unit_amount: number;
//   created_at: string;
//   features: {
//     id: string;
//     name: string;
//   }[];
// };

// type ApiResponse = {
//   statusCode: number;
//   success: boolean;
//   message: string;
//   data: RoomOption[];
// };

// const lessons = [
//   {
//     id: 1,
//     title: '01. Introduction',
//     lecture: '3 lectures',
//     duration: '7 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: '02. Movement in VR',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 3,
//     title: '03. Distance Grabber',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 4,
//     title: '04. Snap Zones',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
// ];

// const tabs = [
//   {
//     id: 1,
//     name: 'Description',
//   },
//   {
//     id: 2,
//     name: 'Lessons',
//   },
//   {
//     id: 3,
//     name: 'Instructor',
//   },
//   {
//     id: 4,
//     name: 'Reviews',
//   },
// ];

// const reviews = [
//   {
//     id: 1,
//     name: 'Lillian Davis',
//     rating: 5,
//     date: 'March 3, 2022',
//     comment: 'Lots of good info.',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/02.jpg',
//   },
//   {
//     id: 2,
//     name: 'Adam Thompson',
//     rating: 5,
//     date: 'March 28, 2022',
//     comment: 'Great course!',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/03.jpg',
//   },
//   {
//     id: 3,
//     name: 'Ryan Howard',
//     rating: 5,
//     date: 'February 12, 2022',
//     comment: 'It was a great course.',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/04.jpg',
//   },
// ];

// export const CourseDetails: React.FC = () => {

//   const location = useLocation();
//   const { pathname } = useLocation();
//   const navigate = hooks.useNavigate();
//   const course = location.state.course;
//   const [selectedTab, setSelectedTab] = useState(tabs[0]);
//   const [coursesData, setCoursesData] = useState<any>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [openItem, setOpenItem] = useState<string | null>(null);

//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   const getData = async () => {
//     setLoading(true);

//     try {
//       const results = await Promise.allSettled([
//         axios.get(URLS.GET_COURSES),
//         // axios.get(URLS.GET_BANNERS),
//       ]);
//       const coursesResponse = properties;
//       if (coursesResponse.status === 'fulfilled') {
//         setCoursesData(coursesResponse.properties);
//       } else {
//         // console.error('Error fetching courses:', coursesResponse.reason);
//       }
//       // const productsResponse = results[0];
//       // const bannersResponse = results[1];
//       // if (productsResponse.status === 'fulfilled') {
//       //   setProductsData(productsResponse.value.data.products);
//       // } else {
//       //   console.error('Error fetching products:', productsResponse.reason);
//       // }
//       // if (bannersResponse.status === 'fulfilled') {
//       //   setBannersData(bannersResponse.value.data.banners);
//       // } else {
//       //   console.error('Error fetching banners:', bannersResponse.reason);
//       // }
//     } catch (error) {
//       console.error('Unexpected error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     getData();
//   }, []);


//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header

//         goBack={true}
//         course={course}
//         addWishlist={true}
//         title={"Model Town, Delhi "}
//       />
//     );
//   };

//   const renderRating = (): JSX.Element => {
//     return (
//       <div
//         style={{ ...utils.rowCenter({ gap: 6 }), marginBottom: 20 }}
//         className='container'
//       >
//         <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
//           <text.T10
//             style={{
//               ...theme.fonts.Lato_700Bold,
//               color: '#FFC700',
//               marginTop: 3,
//             }}
//           >
//             5.0
//           </text.T10>
//           <components.Rating />
//         </div>
//         <text.T10>(149 ratings) 2,719 students</text.T10>
//       </div>
//     );
//   };


//   const renderLocation = (): JSX.Element | null => {
//     let locatonitem = [{
//       id: 1,
//       name: "Dev Rawat",
//       phone: "1234567890",
//       ownertype: "owner",
//       profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
//     }]
//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {locatonitem.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <items.LocationItem
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   };


//   const renderTopRatedCourses = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 80, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Similar Properties'
//           viewAllOnClick={() => {
//             navigate('/category-list', { state: { title: 'Similar Properties' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         {properties?.properties.slice(0, 3).map((course: any, index, array) => {
//           const isLast = index === array.length - 1;

//           return (
//             <elements.CourseCard
//               key={course.id}
//               course={course}
//               isLast={isLast}
//               section='top rated'
//             />
//           );
//         })}

//       </div>
//     );
//   };


//   const renderReview = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Reviews'
//           viewAllVisible={false}
//           viewAllOnClick={() => {
//             // navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <Swiper
//           spaceBetween={16}
//           slidesPerView="auto"
//           pagination={{ clickable: true }}
//           className="review-swiper"
//         >
//           {reviewsData?.map((review: any) => {
//             return (
//               <SwiperSlide key={review.id} className="review-card">
//                 <div className="review-header">
//                   <div className="review-avatar">
//                     {review.image ? (
//                       <img src={review.image} alt={review.name} />
//                     ) : (
//                       <span className="review-initials">
//                         {review.name
//                           ?.split(' ')
//                           .map((n: string) => n[0])
//                           .join('')
//                           .toUpperCase()}
//                       </span>
//                     )}
//                   </div>

//                   <div className="review-info">
//                     <div className="review-name">{review.name}</div>
//                     <div className="review-rating">★ {review.rating}</div>
//                   </div>
//                 </div>

//                 <div className="review-body">
//                   <div className="review-title">{review.title}</div>
//                   <div className="review-description">{review.description}</div>
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>

//       </div>
//     );
//   };


//   // const renderRoomOffer = (): JSX.Element => {
//   //   return (
//   //     <div style={{ marginBottom: 0, marginTop: 40 }}>
//   //       <components.BlockHeading
//   //         title='Room Offering'
//   //         viewAllVisible={false}
//   //         viewAllOnClick={() => {
//   //           // navigate('/category-list', { state: { title: 'Nearest For You' } });
//   //         }}
//   //         containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//   //       />
//   //       <div>
//   //         <h4>Option 1 </h4>
//   //         <div className='sharingType'>
//   //           <p>Multi Sharing</p>
//   //           <p>Rs. 7,500/bed</p>
//   //         </div>
//   //         <div className='depositAmount'>
//   //           <p>One Time Security Deposit</p>
//   //           <p>Rs. 10,000</p>
//   //         </div>
//   //         <p>Services </p>
//   //         <ul>
//   //           <li>AC</li>
//   //           <li>Attached Balcony</li>
//   //           <li>Attached Bathroom</li>
//   //         </ul>
//   //       </div>

//   //     </div>
//   //   );
//   // };

//   // const renderRoomOffer = (): JSX.Element => {
//   //   return (
//   //     <div className='RoomTypeContainer' style={{ marginBottom: 0, marginTop: 40, padding: "0px 20px" }}>
//   //       <components.BlockHeading
//   //         title='Room Offering'
//   //         viewAllVisible={false}
//   //         viewAllOnClick={() => {
//   //           // navigate('/category-list', { state: { title: 'Nearest For You' } });
//   //         }}
//   //         containerStyle={{ marginBottom: 12 }}
//   //       />
//   //       {/* Multi */}
//   //       <div className='RoomTypeContent'>
//   //         <h4>Option 1 </h4>
//   //         <div className='sharingType'>
//   //           <p >Multi Sharing</p>
//   //           <p>Rs. 7,500/bed</p>
//   //         </div>
//   //         <div className='depositAmount'>
//   //           <p>One Time Security Deposit</p>
//   //           <p>Rs. 10,000</p>
//   //         </div>
//   //         <p className='servicesRoom'>Services </p>
//   //         <ul>
//   //           <li>AC</li>
//   //           <li>Attached Balcony</li>
//   //           <li>Attached Bathroom</li>
//   //         </ul>
//   //       </div>

//   //       {/* Single Sharing */}
//   //       <div className='RoomTypeContent'>
//   //         <h4>Option 2 </h4>
//   //         <div className='sharingType'>
//   //           <p >Single Sharing</p>
//   //           <p>Rs. 7,500/bed</p>
//   //         </div>
//   //         <div className='depositAmount'>
//   //           <p>One Time Security Deposit</p>
//   //           <p>Rs. 10,000</p>
//   //         </div>
//   //         <p className='servicesRoom'>Services </p>
//   //         <ul>
//   //           <li>AC</li>
//   //           <li>Attached Balcony</li>
//   //           <li>Attached Bathroom</li>
//   //         </ul>
//   //       </div>
//   //       {/* Double Sharing */}
//   //       <div className='RoomTypeContent'>
//   //         <h4>Option 3 </h4>
//   //         <div className='sharingType'>
//   //           <p >Double Sharing</p>
//   //           <p>Rs. 7,500/bed</p>
//   //         </div>
//   //         <div className='depositAmount'>
//   //           <p>One Time Security Deposit</p>
//   //           <p>Rs. 10,000</p>
//   //         </div>
//   //         <p className='servicesRoom'>Services </p>
//   //         <ul>
//   //           <li>AC</li>
//   //           <li>Attached Balcony</li>
//   //           <li>Attached Bathroom</li>
//   //         </ul>
//   //       </div>
//   //       {/* Private Room */}
//   //       <div className='RoomTypeContent'>
//   //         <h4>Option 4 </h4>
//   //         <div className='sharingType'>
//   //           <p >Private </p>
//   //           <p>Rs. 7,500/bed</p>
//   //         </div>
//   //         <div className='depositAmount'>
//   //           <p>One Time Security Deposit</p>
//   //           <p>Rs. 10,000</p>
//   //         </div>
//   //         <p className='servicesRoom'>Services </p>
//   //         <ul>
//   //           <li>AC</li>
//   //           <li>Attached Balcony</li>
//   //           <li>Attached Bathroom</li>
//   //         </ul>
//   //       </div>


//   //     </div>
//   //   );
//   // };

//   const roomOptions = [
//     {
//       title: 'Option 1',
//       sharingType: 'Multi Sharing',
//       price: 'Rs. 6,000/bed',
//       deposit: 'Rs. 8,000',
//       services: ['Wi-Fi', 'Housekeeping', 'Laundry', 'AC'],
//     },
//     {
//       title: 'Option 2',
//       sharingType: 'Single Sharing',
//       price: 'Rs. 10,000/bed',
//       deposit: 'Rs. 12,000',
//       services: ['Wi-Fi', 'Attached Bathroom'],
//     },
//     {
//       title: 'Option 3',
//       sharingType: 'Double Sharing',
//       price: 'Rs. 8,000/bed',
//       deposit: 'Rs. 9,000',
//       services: ['AC', 'Shared Kitchen', 'Housekeeping', 'Wi-Fi', 'Laundry', 'Common Area'],
//     },
//     {
//       title: 'Option 4',
//       sharingType: 'Private',
//       price: 'Rs. 12,000/bed',
//       deposit: 'Rs. 15,000',
//       services: ['AC', 'Private Bathroom', '24x7 Power Backup', 'Wi-Fi', 'Fridge', 'Geyser'],
//     },
//   ];


//   const renderRoomOffer = (): JSX.Element => {
//     return (
//       <div className='RoomTypeContainer' style={{ marginBottom: 0, marginTop: 40, padding: '0px 20px' }}>
//         <components.BlockHeading
//           title='Room Offering'
//           viewAllVisible={false}
//           viewAllOnClick={() => {
//             // navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12 }}
//         />

//         {roomOptions.map((room, index) => (
//           <div className='RoomTypeContent' key={index}>
//             <h4>{room.title}</h4>
//             <div className='sharingType'>
//               <p>{room.sharingType}</p>
//               <p>{room.price}</p>
//             </div>
//             <div className='depositAmount'>
//               <p>One Time Security Deposit</p>
//               <p>{room.deposit}</p>
//             </div>
//             <p className='servicesRoom'>Services </p>
//             <ul>
//               {room.services.map((service, i) => (
//                 <li key={i}>{service}</li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>
//     );
//   };



//   const renderLocationMap = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Property Location'
//           viewAllVisible={false}
//           viewAllOnClick={() => {
//             // navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />

//         <div style={{ width: '100%', maxWidth: '600px', margin: '0 auto' }}>
//           <iframe
//             title="Noida Sector 16 Location"
//             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.712100232856!2d77.31495772549884!3d28.578406725694343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce45b03df3a13%3A0xaeba1ce26aa125fc!2sNoida%20Sec%2016!5e0!3m2!1sen!2sin!4v1749128786731!5m2!1sen!2sin"
//             width="100%"
//             height="250"
//             style={{ border: 0 }}
//             allowFullScreen
//             loading="lazy"
//             referrerPolicy="no-referrer-when-downgrade"
//           ></iframe>
//         </div>

//       </div>
//     );
//   };

//   const renderKeyHighlights = (): JSX.Element => {
//     return (
//       <div className='container whyYouChooseProperties' style={{ marginBottom: 30, padding: "20px 28px", backgroundColor: "#f0fff0" }} >
//         <div className="highlightContainer">
//           <div className="highlightImage">
//             <img src={goal} alt="Goal" />
//           </div>
//           <div className="highlightText">
//             <p className="headingChoose">Other Key Highlights</p>
//             <p>Why you should choose the property</p>
//           </div>
//         </div>
//         <ul className="whyChooseList">
//           <li>
//             <img src={checkIcon} alt="check" className="listIcon" />
//             Prime location & transport access
//           </li>
//           <li>
//             <img src={checkIcon} alt="check" className="listIcon" />
//             Spacious, modern interiors
//           </li>
//           <li>
//             <img src={checkIcon} alt="check" className="listIcon" />
//             24/7 security system
//           </li>
//           <li>
//             <img src={checkIcon} alt="check" className="listIcon" />
//             Eco-friendly with green space
//           </li>
//           <li>
//             <img src={checkIcon} alt="check" className="listIcon" />
//             Great value & ROI
//           </li>
//         </ul>


//       </div >
//     );
//   };
//   // Function to render the Amenities as individual blocks





//   const renderScheduleButton = (): JSX.Element => {
//     return (
//       <div style={{ padding: '20px', textAlign: 'center', width: "100%" }}>
//         <button
//           style={{
//             backgroundColor: '#4B6EF5',         // Primary color
//             color: '#ffffff',                   // White text
//             padding: '12px 24px',
//             border: 'none',
//             borderRadius: '8px',
//             fontSize: '16px',
//             fontWeight: 600,
//             cursor: 'pointer',
//             width: "100%",
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//             transition: 'all 0.3s ease',
//           }}
//           onClick={() => alert('Visit scheduled!')}
//           onMouseEnter={(e) =>
//             ((e.target as HTMLButtonElement).style.backgroundColor = '#3a59d8')
//           }
//           onMouseLeave={(e) =>
//             ((e.target as HTMLButtonElement).style.backgroundColor = '#4B6EF5')
//           }
//         >
//           Schedule Your Visit
//         </button>
//       </div>
//     );
//   };


//   // Render Component

//   const renderPreviewImage = (): JSX.Element => {
//     const images = course.previewImages || [course.preview_90x90];
//     return (
//       <div style={{ marginTop: 20, marginBottom: 20 }} className='container-fluid'>
//         <Swiper
//           spaceBetween={16}
//           slidesPerView={1}
//           navigation
//           pagination={{ clickable: true }}
//           loop
//         >
//           {images.map((image: any, index: any) => (
//             <SwiperSlide key={index}>
//               <img
//                 src={image}
//                 alt={`Preview ${index + 1}`}
//                 style={{
//                   width: '100%',
//                   objectFit: 'cover',
//                   borderRadius: 10,
//                   height: 200,
//                 }}
//               />
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     );
//   };


//   const renderTitle = (): JSX.Element => {
//     return (
//       <div className='container propertiesDetails'>
//         <p className='typeOfRoom'  >Semi Furnished</p>
//         <text.H4
//           style={{ marginBottom: 6 }}
//           numberOfLines={2}
//         >
//           {/* {course.name} */}
//           PG Accommodation in Downtown
//         </text.H4>
//       </div>
//     );
//   };

//   // room types 
//   const renderFlatOpton = (): JSX.Element => {

//     let options = [{
//       id: 1,
//       amount: "8000",
//       roomtype: "Flat",
//       address: "Gurgaon,ram colony,Delhi.",
//       securtydeposit: "25000",
//       totalbeds: "3",
//       totabatrooms: "2",
//       area: "50",
//       profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
//     }]


//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {options.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <FlatPrices
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   }

//   const renderOwner = (): JSX.Element | null => {

//     let propertyOwner = [{
//       id: 1,
//       name: "Vikas Kumar",
//       phone: "1234567890",
//       ownertype: "owner",
//       profileimage: "https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
//     }]
//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {propertyOwner.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <PropertiyOwner
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   };


//   // const renderAmenities = (): JSX.Element => {
//   //   const amenitiesList = [
//   //     { id: 1, name: 'Infinity Pool', icon: <FontAwesomeIcon icon={faSwimmingPool} color='#7065F0' /> },
//   //     { id: 2, name: 'Sunset View', icon: <FontAwesomeIcon icon={faSun} color='#7065F0' /> },
//   //     { id: 3, name: 'Gym Center', icon: <FontAwesomeIcon icon={faDumbbell} color='#7065F0' /> },
//   //     { id: 4, name: 'Work Station', icon: <FontAwesomeIcon icon={faLaptop} color='#7065F0' /> },
//   //     { id: 5, name: 'Free Bike', icon: <FontAwesomeIcon icon={faBicycle} color='#7065F0' /> },
//   //     { id: 6, name: 'Airport Shuttle', icon: <FontAwesomeIcon icon={faShuttleVan} color='#7065F0' /> },
//   //     { id: 7, name: 'Baby Ground', icon: <FontAwesomeIcon icon={faBaby} color='#7065F0' /> },
//   //     { id: 8, name: 'Meeting Room', icon: <FontAwesomeIcon icon={faDoorClosed} color='#7065F0' /> },
//   //   ];
//   //   return (
//   //     <div style={{ marginBottom: 0, marginTop: 40 }}>
//   //       <BlockHeading
//   //         title={'Aminities'}

//   //         viewAllOnClick={() => {
//   //           navigate('/aminity-list', { state: { title: 'Aminities List' } });
//   //         }}
//   //         containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//   //       />
//   //       <Swiper spaceBetween={8} slidesPerView={3} pagination={{ clickable: true }}>
//   //         {amenitiesList.map((item) => (
//   //           <SwiperSlide
//   //             key={item.id}
//   //             style={{
//   //               width: 160,
//   //               // backgroundColor: '#EFEEFB',
//   //               borderRadius: 10,
//   //               padding: 8,
//   //               display: 'flex',
//   //               flexDirection: 'column',
//   //               justifyContent: 'center',
//   //               alignItems: 'center',
//   //               minHeight: 120,
//   //               boxSizing: 'border-box',
//   //               cursor: 'pointer',
//   //               userSelect: 'none',
//   //               overflow: 'hidden',
//   //               textAlign: 'center',
//   //             }}
//   //           >
//   //             <div style={{ fontSize: 18, color: '#444' }}>
//   //               {item.icon}
//   //             </div>
//   //             <div style={{ marginTop: 12, fontWeight: 600, fontSize: 14, color: '#444' }}>
//   //               {item.name}
//   //             </div>
//   //           </SwiperSlide>
//   //         ))}
//   //       </Swiper>

//   //     </div>
//   //   );
//   // };


//   const renderAmenities = (): JSX.Element => {
//     const amenitiesList = [
//       { id: 1, name: 'Infinity Pool', icon: <FontAwesomeIcon icon={faSwimmingPool} color='#7065F0' /> },
//       { id: 2, name: 'Sunset View', icon: <FontAwesomeIcon icon={faSun} color='#7065F0' /> },
//       { id: 3, name: 'Gym Center', icon: <FontAwesomeIcon icon={faDumbbell} color='#7065F0' /> },
//       { id: 4, name: 'Work Station', icon: <FontAwesomeIcon icon={faLaptop} color='#7065F0' /> },
//       // { id: 5, name: 'Free Bike', icon: <FontAwesomeIcon icon={faBicycle} color='#7065F0' /> },
//       // { id: 6, name: 'Airport Shuttle', icon: <FontAwesomeIcon icon={faShuttleVan} color='#7065F0' /> },
//       { id: 7, name: 'Baby Ground', icon: <FontAwesomeIcon icon={faBaby} color='#7065F0' /> },
//       { id: 8, name: 'Meeting Room', icon: <FontAwesomeIcon icon={faDoorClosed} color='#7065F0' /> },
//     ];

//     return (
//       <div className="amenities-wrapper" style={{ marginBottom: 30 }}>
//         <BlockHeading

//           title="Amenities"
//           viewAllOnClick={() => {
//             navigate('/aminity-list', { state: { title: 'Amenities List' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <div className="amenities-grid">
//           {amenitiesList.slice(0, 6).map((item) => (
//             <div key={item.id} className="amenity-card">
//               <div className="amenity-icon">{item.icon}</div>
//               <div className="amenity-name">{item.name}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   };




//   const propertyDetails = (): JSX.Element => {
//     const details = [
//       { label: 'Furnished', value: 'Semi Furnished' },
//       { label: 'Ownership', value: 'Leasehold' },
//       { label: 'Security Deposit', value: '₹ 5,000' },
//       { label: 'Agreement', value: '3 Months' },
//       { label: 'Locking Period', value: '4 Months' },
//       { label: 'Notice Period', value: '4 Months' },
//     ];

//     return (
//       <div className='container'>
//         <div className='propertyContainer'>
//           <p className="property-details">Property Details</p>
//           <div className='detailsValue'>
//             {details.map((item, index) => (
//               <div className='propertyDetails-content' key={index}>
//                 <p>{item.label}</p>
//                 <p>{item.value}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   };


//   const renderBottomTabBar = (): JSX.Element => {
//     return <components.BottomTabBar />;
//   };



//   // const renderBottomButton = (): JSX.Element => {
//   //   return (
//   //     <div
//   //       style={{
//   //         position: "fixed",
//   //         bottom: 0,
//   //         width: "100%",
//   //         backgroundColor: "#ffffff",
//   //         boxShadow: "0 -4px 12px rgba(0, 0, 0, 0.1)",
//   //         padding: "12px 16px",
//   //         display: "flex",
//   //         justifyContent: "space-between",
//   //         alignItems: "center",
//   //         gap: "10px",
//   //         zIndex: 999,
//   //       }}
//   //     >
//   //       <button
//   //         onClick={() => window.open("https://wa.me/919999999999", "_blank")}
//   //         style={{
//   //           flex: 1,
//   //           backgroundColor: "#25D366",
//   //           color: "white",
//   //           border: "none",
//   //           borderRadius: "10px",
//   //           padding: "12px",
//   //           fontSize: "14px",
//   //           fontWeight: "bold",
//   //           cursor: "pointer",
//   //         }}
//   //       >
//   //         {/* WhatsApp Chat */}
//   //         <WhatsappSvg />
//   //       </button>

//   //       <button
//   //         onClick={() => (window.location.href = "tel:+919999999999")}
//   //         style={{
//   //           flex: 1,
//   //           backgroundColor: "#007BFF",
//   //           color: "white",
//   //           border: "none",
//   //           borderRadius: "10px",
//   //           padding: "12px",
//   //           fontSize: "14px",
//   //           fontWeight: "bold",
//   //           cursor: "pointer",
//   //         }}
//   //       >
//   //         Call Now
//   //       </button>

//   //       <button
//   //         onClick={() => alert("Request submitted!")}
//   //         style={{
//   //           flex: 1,
//   //           backgroundColor: "#FFC107",
//   //           color: "#000",
//   //           border: "none",
//   //           borderRadius: "10px",
//   //           padding: "12px",
//   //           fontSize: "14px",
//   //           fontWeight: "bold",
//   //           cursor: "pointer",
//   //         }}
//   //       >
//   //         Request
//   //       </button>
//   //     </div>
//   //   );
//   // };



//   const renderBottomButton = (): JSX.Element => {
//     return (
//       <div className="bottom-button-container">
//         {/* <button
//           onClick={() => window.open("https://wa.me/919999999999", "_blank")}
//           className="bottom-button whatsapp-button"
//         >
//           <WhatsappSvg />
//         </button> */}

//         <button
//           onClick={() => window.open("https://wa.me/919999999999", "_blank")}
//           className="bottom-button whatsapp-button"
//         >
//           <WhatsappSvg className="whatsapp-icon-animate" />
//         </button>

//         <button
//           onClick={() => (window.location.href = "tel:+919999999999")}
//           className="bottom-button call-button "
//         >
//           Call Now
//         </button>

//         <button
//           onClick={() => setIsModalOpen(true)}
//           className="bottom-button request-button"
//         >
//           Book Now
//         </button>


//         {isModalOpen && (
//           <div className="modal-overlay">
//             <div className="modal-content">
//               <h2>Book Your Room</h2>
//               <form>
//                 <label>
//                   Select Room Type:
//                   <select required>
//                     <option value="">-- Choose an option --</option>
//                     <option value="multi">Multi Sharing</option>
//                     <option value="single">Single Sharing</option>
//                     <option value="double">Double Sharing</option>
//                     <option value="private">Private</option>
//                   </select>
//                 </label>

//                 <label>
//                   Payment Amount:
//                   <input type="text" value="Rs. 10,000" readOnly />
//                 </label>

//                 <label>
//                   GST (18%):
//                   <input type="text" value="Rs. 1,800" readOnly />
//                 </label>

//                 <label>
//                   Total Payable:
//                   <input type="text" value="Rs. 11,800" readOnly />
//                 </label>

//                 <div className="modal-buttons">
//                   <button
//                     type="button"
//                     className="cancel-button"
//                     onClick={() => setIsModalOpen(false)}
//                   >
//                     Cancel
//                   </button>
//                   <div className="pay-button"
//                     onClick={() => navigate('/choose-payment-method')}
//                   >Confirm</div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };


//   const renderContent = (): JSX.Element => {
//     return (
//       <main style={{ paddingBottom: 0 }}>
//         {renderPreviewImage()}
//         {renderTitle()}
//         {renderFlatOpton()}
//         {renderOwner()}
//         {propertyDetails()}
//         {renderRoomOffer()}
//         {renderAmenities()}
//         {renderKeyHighlights()}
//         {renderLocationMap()}
//         {renderReview()}
//         {renderTopRatedCourses()}
//         {renderBottomButton()}
//         {/* {renderBottomTabBar()} */}


//         {/* {renderScheduleButton()} */}
//         {/* {renderLocation()} */}
//       </main>
//     );
//   };

//   return (
//     <>
//       {/*  */}
//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };

















// ******************************OLD CODE ************************

// import axios from 'axios';
// import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import * as Accordion from '@radix-ui/react-accordion';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSwimmingPool, faSun, faDumbbell, faLaptop, faBicycle, faShuttleVan, faBaby, faDoorClosed } from '@fortawesome/free-solid-svg-icons';




// import { text } from '../text';
// import { URLS } from '../config';
// import { hooks } from '../hooks';
// import { utils } from '../utils';
// import { items } from '../items';
// import { svg } from '../assets/svg';
// import { theme } from '../constants';
// import { components } from '../components';
// import { course as elements } from '../course';
// import properties from '../staticdata/properties';
// import { reviewsData } from '../staticdata/reviewData';
// import { ReviewCard } from '../reviews/reviewCard';
// import { roomTypes } from '../staticdata/roomOptions';
// import { FlatPrices } from '../items/Flattypes';
// import { PropertiyOwner } from '../items/PropertyOwner';
// import { BlockHeading } from '../components/BlockHeading';

// type RoomOption = {
//   property_room_option_id: string;
//   property_id: string;
//   room_type_id: string;
//   option_name: string;
//   unit_amount: number;
//   created_at: string;
//   features: {
//     id: string;
//     name: string;
//   }[];
// };

// type ApiResponse = {
//   statusCode: number;
//   success: boolean;
//   message: string;
//   data: RoomOption[];
// };

// const lessons = [
//   {
//     id: 1,
//     title: '01. Introduction',
//     lecture: '3 lectures',
//     duration: '7 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: '02. Movement in VR',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 3,
//     title: '03. Distance Grabber',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
//   {
//     id: 4,
//     title: '04. Snap Zones',
//     lecture: '8 lectures',
//     duration: '1h 33 min',
//     content: [
//       {
//         id: 1,
//         title: 'Setting up individual Camera Rigs',
//         duration: '00:44',
//       },
//       {
//         id: 2,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '03:49',
//       },
//       {
//         id: 3,
//         title: 'Setting Up VRTKs Tracked Alias',
//         duration: '02:22',
//         locked: true,
//       },
//     ],
//   },
// ];

// const tabs = [
//   {
//     id: 1,
//     name: 'Description',
//   },
//   {
//     id: 2,
//     name: 'Lessons',
//   },
//   {
//     id: 3,
//     name: 'Instructor',
//   },
//   {
//     id: 4,
//     name: 'Reviews',
//   },
// ];

// const reviews = [
//   {
//     id: 1,
//     name: 'Lillian Davis',
//     rating: 5,
//     date: 'March 3, 2022',
//     comment: 'Lots of good info.',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/02.jpg',
//   },
//   {
//     id: 2,
//     name: 'Adam Thompson',
//     rating: 5,
//     date: 'March 28, 2022',
//     comment: 'Great course!',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/03.jpg',
//   },
//   {
//     id: 3,
//     name: 'Ryan Howard',
//     rating: 5,
//     date: 'February 12, 2022',
//     comment: 'It was a great course.',
//     avatar: 'https://george-fx.github.io/nuton_api/assets/users/04.jpg',
//   },
// ];

// export const CourseDetails: React.FC = () => {
//   const location = useLocation();
//   const { pathname } = useLocation();

//   const navigate = hooks.useNavigate();

//   const course = location.state.course;

//   const [selectedTab, setSelectedTab] = useState(tabs[0]);
//   const [coursesData, setCoursesData] = useState<any>([]);
//   const [loading, setLoading] = useState<boolean>(false);
//   const [openItem, setOpenItem] = useState<string | null>(null);

//   useEffect(() => {
//     const scrollToTop = () => {
//       window.scrollTo(0, 0);
//       document.documentElement.scrollTop = 0;
//     };

//     scrollToTop();
//   }, [pathname]);

//   const getData = async () => {
//     setLoading(true);

//     try {
//       const results = await Promise.allSettled([
//         axios.get(URLS.GET_COURSES),
//         // axios.get(URLS.GET_BANNERS),
//       ]);
//       const coursesResponse = properties;
//       if (coursesResponse.status === 'fulfilled') {
//         setCoursesData(coursesResponse.properties);
//       } else {
//         // console.error('Error fetching courses:', coursesResponse.reason);
//       }
//       // const productsResponse = results[0];
//       // const bannersResponse = results[1];
//       // if (productsResponse.status === 'fulfilled') {
//       //   setProductsData(productsResponse.value.data.products);
//       // } else {
//       //   console.error('Error fetching products:', productsResponse.reason);
//       // }
//       // if (bannersResponse.status === 'fulfilled') {
//       //   setBannersData(bannersResponse.value.data.banners);
//       // } else {
//       //   console.error('Error fetching banners:', bannersResponse.reason);
//       // }
//     } catch (error) {
//       console.error('Unexpected error:', error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     getData();
//   }, []);


//   const renderHeader = (): JSX.Element => {
//     return (
//       <components.Header
//         goBack={true}
//         course={course}
//         addWishlist={true}
//       />
//     );
//   };

//   const renderRating = (): JSX.Element => {
//     return (
//       <div
//         style={{ ...utils.rowCenter({ gap: 6 }), marginBottom: 20 }}
//         className='container'
//       >
//         <div style={{ ...utils.rowCenter({ gap: 3 }) }}>
//           <text.T10
//             style={{
//               ...theme.fonts.Lato_700Bold,
//               color: '#FFC700',
//               marginTop: 3,
//             }}
//           >
//             5.0
//           </text.T10>
//           <components.Rating />
//         </div>
//         <text.T10>(149 ratings) 2,719 students</text.T10>
//       </div>
//     );
//   };


//   const renderLocation = (): JSX.Element | null => {
//     let locatonitem = [{
//       id: 1,
//       name: "Dev Rawat",
//       phone: "1234567890",
//       ownertype: "owner",
//       profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
//     }]
//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {locatonitem.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <items.LocationItem
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   };
//   const renderTopRatedCourses = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Similar Properties'
//           viewAllOnClick={() => {
//             navigate('/category-list', { state: { title: 'Similar Properties' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         {properties?.properties.slice(0, 3).map((course: any, index, array) => {
//           const isLast = index === array.length - 1;

//           return (
//             <elements.CourseCard
//               key={course.id}
//               course={course}
//               isLast={isLast}
//               section='top rated'
//             />
//           );
//         })}

//       </div>
//     );
//   };
//   const renderReview = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <components.BlockHeading
//           title='Reviews'
//           viewAllVisible={false}
//           viewAllOnClick={() => {
//             // navigate('/category-list', { state: { title: 'Nearest For You' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <Swiper
//           spaceBetween={16}
//           slidesPerView="auto"
//           // centeredSlides={true}
//           pagination={{ clickable: true }}
//         >
//           {reviewsData?.map((review: any, index: any, array: any) => {
//             const isLast = index === array.length - 1;
//             return (
//               <SwiperSlide
//                 key={review.id}
//                 style={{
//                   width: 250,
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   borderRadius: 10,
//                   display: 'flex',
//                   flexDirection: 'column',
//                   position: 'relative',
//                   backgroundColor: "#F9FAFC",
//                   // padding: "20px 20px 0px 20px"

//                 }}
//                 onClick={() => {
//                   // navigate('/course-details', { state: { review } });
//                 }}
//               >
//                 <div
//                   style={{
//                     position: 'relative',
//                     width: 60,
//                     height: 60,
//                     marginTop: 20,
//                     marginBottom: 20,
//                     marginLeft: 18

//                   }}
//                 >
//                   <img
//                     src={review.image}
//                     alt={review.name}
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       objectFit: 'cover',     // Makes sure the image fills the circle
//                       position: 'absolute',
//                       borderRadius: '50%',    // Makes the image circular
//                       inset: 0,
//                     }}
//                   />
//                 </div>

//                 <div style={{}}>
//                   <ReviewCard
//                     review={review}
//                     section='review'
//                   />
//                 </div>
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>
//       </div>
//     );
//   };

//   const renderRoomTypes = (): JSX.Element => {
//     return (
//       <div style={{ marginBottom: 30 }}>
//         {/* <components.BlockHeading
//           title="Specially for you"
//           viewAllOnClick={() => {
//             navigate('/category-list', {
//               state: { title: 'Specially for you' },
//             });
//           }}
//           containerStyle={{ marginBottom: 7, padding: '0 20px' }}
//         /> */}
//         <Swiper
//           spaceBetween={16}
//           slidesPerView={'auto'}
//           pagination={{ clickable: true }}
//         >
//           {roomTypes?.data?.map((room, index) => {
//             return (
//               <SwiperSlide
//                 key={index}
//                 style={{
//                   width: 260,
//                   backgroundColor: '#F9FAFC',
//                   // backgroundColor: index % 2 === 0 ? '#FDF4EF' : '#EEF7FE',
//                   borderRadius: 10,
//                   borderColor: "border: 1px solid #EFEEFB",
//                   padding: 16,
//                   position: 'relative',
//                   cursor: 'pointer',
//                   userSelect: 'none',
//                   overflow: 'hidden',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   justifyContent: 'space-around',
//                   minHeight: 150, // Increased height to accommodate features
//                 }}
//               >
//                 {/* Decorative circle */}
//                 {/* <div
//                   style={{
//                     width: 100,
//                     height: 100,
//                     backgroundColor: '#FED7C7',
//                     borderRadius: 50,
//                     position: 'absolute',
//                     right: -20,
//                     bottom: -20,
//                   }}
//                 /> */}
//                 {/* Room name and price */}
//                 <div style={{ zIndex: 1 }}>
//                   <div
//                     style={{
//                       fontWeight: 600,
//                       fontSize: 16,
//                       marginBottom: 4,
//                       color: theme.colors.bodyTextColor,
//                     }}
//                   >
//                     {room.option_name}
//                   </div>
//                   <div
//                     style={{
//                       fontSize: 14,
//                       color: theme.colors.secondaryTextColor,
//                     }}
//                   >
//                     ₹{room.unit_amount.toLocaleString()} / month
//                   </div>
//                 </div>
//                 <div style={{ marginTop: 0, zIndex: 1 }}>
//                   {room.features.reduce((rows: JSX.Element[][], feature, index) => {
//                     const rowIndex = Math.floor(index / 2);
//                     if (!rows[rowIndex]) rows[rowIndex] = [];
//                     rows[rowIndex].push(
//                       <div
//                         key={feature.feature_id}
//                         style={{
//                           flex: 1,
//                           fontSize: 12,
//                           color: theme.colors.secondaryTextColor,
//                           whiteSpace: 'nowrap',
//                           overflow: 'hidden',
//                           textOverflow: 'ellipsis',
//                         }}
//                       >
//                         • {feature.feature_name}
//                       </div>
//                     );
//                     return rows;
//                   }, []).map((row, i) => (
//                     <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 4 }}>
//                       {row}
//                     </div>
//                   ))}
//                 </div>

//               </SwiperSlide>

//             );
//           })}
//         </Swiper>
//       </div>
//     );
//   };
//   // Function to render the Amenities as individual blocks


//   const renderScheduleButton = (): JSX.Element => {
//     return (
//       <div style={{ padding: '20px', textAlign: 'center', width: "100%" }}>
//         <button
//           style={{
//             backgroundColor: '#4B6EF5',         // Primary color
//             color: '#ffffff',                   // White text
//             padding: '12px 24px',
//             border: 'none',
//             borderRadius: '8px',
//             fontSize: '16px',
//             fontWeight: 600,
//             cursor: 'pointer',
//             width: "100%",
//             boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//             transition: 'all 0.3s ease',
//           }}
//           onClick={() => alert('Visit scheduled!')}
//           onMouseEnter={(e) =>
//             ((e.target as HTMLButtonElement).style.backgroundColor = '#3a59d8')
//           }
//           onMouseLeave={(e) =>
//             ((e.target as HTMLButtonElement).style.backgroundColor = '#4B6EF5')
//           }
//         >
//           Schedule Your Visit
//         </button>
//       </div>
//     );
//   };


//   // Render Component

//   const renderPreviewImage = (): JSX.Element => {
//     const images = course.previewImages || [course.preview_90x90];
//     return (
//       <div style={{ marginTop: 20, marginBottom: 20 }} className='container-fluid'>
//         <Swiper
//           spaceBetween={16}
//           slidesPerView={1}
//           navigation
//           pagination={{ clickable: true }}
//           loop
//         >
//           {images.map((image: any, index: any) => (
//             <SwiperSlide key={index}>
//               <img
//                 src={image}
//                 alt={`Preview ${index + 1}`}
//                 style={{
//                   width: '100%',
//                   objectFit: 'cover',
//                   borderRadius: 10,
//                   height: 200,
//                 }}
//               />
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     );
//   };


//   const renderTitle = (): JSX.Element => {
//     return (
//       <div className='container propertiesDetails'>
//         <p className='typeOfRoom'  >Semi Furnished</p>
//         <text.H4
//           style={{ marginBottom: 6 }}
//           numberOfLines={2}
//         >
//           {course.name}
//         </text.H4>
//       </div>
//     );
//   };

//   // room types 
//   const renderFlatOpton = (): JSX.Element => {

//     let options = [{
//       id: 1,
//       amount: "8000",
//       roomtype: "Flat",
//       address: "Gurgaon,ram colony,Delhi.",
//       securtydeposit: "25000",
//       totalbeds: "3",
//       totabatrooms: "2",
//       area: "50",
//       profileimage: "https://george-fx.github.io/nuton_api/assets/users/04.jpg"
//     }]


//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {options.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <FlatPrices
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   }

//   const renderOwner = (): JSX.Element | null => {

//     let propertyOwner = [{
//       id: 1,
//       name: "Vikas Kumar",
//       phone: "1234567890",
//       ownertype: "owner",
//       profileimage: "https://media.istockphoto.com/id/1131164548/vector/avatar-5.jpg?s=612x612&w=0&k=20&c=CK49ShLJwDxE4kiroCR42kimTuuhvuo2FH5y_6aSgEo="
//     }]
//     return (
//       <div
//         style={{ marginBottom: 20 }}
//         className='container'
//       >
//         {propertyOwner.map((item, index, array) => {
//           const isLast = index === array.length - 1;
//           return (
//             <PropertiyOwner
//               key={item.id}
//               review={item}
//               isLast={isLast}
//             />
//           );
//         })}
//       </div>
//     );
//   };

//   const renderAmenities = (): JSX.Element => {
//     const amenitiesList = [
//       { id: 1, name: 'Infinity Pool', icon: <FontAwesomeIcon icon={faSwimmingPool} color='#7065F0' /> },
//       { id: 2, name: 'Sunset View', icon: <FontAwesomeIcon icon={faSun} color='#7065F0' /> },
//       { id: 3, name: 'Gym Center', icon: <FontAwesomeIcon icon={faDumbbell} color='#7065F0' /> },
//       { id: 4, name: 'Work Station', icon: <FontAwesomeIcon icon={faLaptop} color='#7065F0' /> },
//       { id: 5, name: 'Free Bike', icon: <FontAwesomeIcon icon={faBicycle} color='#7065F0' /> },
//       { id: 6, name: 'Airport Shuttle', icon: <FontAwesomeIcon icon={faShuttleVan} color='#7065F0' /> },
//       { id: 7, name: 'Baby Ground', icon: <FontAwesomeIcon icon={faBaby} color='#7065F0' /> },
//       { id: 8, name: 'Meeting Room', icon: <FontAwesomeIcon icon={faDoorClosed} color='#7065F0' /> },
//     ];
//     return (
//       <div style={{ marginBottom: 0, marginTop: 40 }}>
//         <BlockHeading
//           title={'Aminities'}

//           viewAllOnClick={() => {
//             navigate('/aminity-list', { state: { title: 'Aminities List' } });
//           }}
//           containerStyle={{ marginBottom: 12, padding: '0 20px' }}
//         />
//         <Swiper spaceBetween={8} slidesPerView={3} pagination={{ clickable: true }}>
//           {amenitiesList.map((item) => (
//             <SwiperSlide
//               key={item.id}
//               style={{
//                 width: 160,
//                 // backgroundColor: '#EFEEFB',
//                 borderRadius: 10,
//                 padding: 8,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 minHeight: 120,
//                 boxSizing: 'border-box',
//                 cursor: 'pointer',
//                 userSelect: 'none',
//                 overflow: 'hidden',
//                 textAlign: 'center',
//               }}
//             >
//               <div style={{ fontSize: 18, color: '#444' }}>
//                 {item.icon}
//               </div>
//               <div style={{ marginTop: 12, fontWeight: 600, fontSize: 14, color: '#444' }}>
//                 {item.name}
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//         <Swiper spaceBetween={8} slidesPerView={3} pagination={{ clickable: true }}>
//           {amenitiesList.map((item) => (
//             <SwiperSlide
//               key={item.id}
//               style={{
//                 width: 160,
//                 // backgroundColor: '#EFEEFB',
//                 borderRadius: 10,
//                 padding: 8,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 minHeight: 120,
//                 boxSizing: 'border-box',
//                 cursor: 'pointer',
//                 userSelect: 'none',
//                 overflow: 'hidden',
//                 textAlign: 'center',
//               }}
//             >
//               <div style={{ fontSize: 18, color: '#444' }}>
//                 {item.icon}
//               </div>
//               <div style={{ marginTop: 12, fontWeight: 600, fontSize: 14, color: '#444' }}>
//                 {item.name}
//               </div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     );
//   };


//   const renderContent = (): JSX.Element => {
//     return (
//       <main style={{ paddingBottom: 0 }}>
//         {renderPreviewImage()}
//         {renderTitle()}
//         {renderFlatOpton()}
//         {renderOwner()}
//         {renderAmenities()}
//         {/* renderTopRatedCourses() */}
//         {/* {renderReview()} */}
//         {/* {renderScheduleButton()} */}
//         {/* {renderRoomTypes()} */}
//         {/* {renderLocation()} */}
//       </main>
//     );
//   };

//   return (
//     <>
//       {/*  */}
//       {renderHeader()}
//       {renderContent()}
//     </>
//   );
// };
